<template>

<div class="container">
        <div class="row justify-content-center mt-4">
            <div class=" col-12 col-md-6 mt-4">
                 <div class="form-floating ">
              
  <select v-model="chosenTemplate" class="form-select" id="template" >
    <option value="0">აირჩიე შაბლონი...</option>

    <option v-for="data of templates" :key="data.applicationID" :value="data.applicationID">{{ data.applicationName }}</option>
 

  </select>
</div>



 

 <div class="form-floating mt-3" v-if="chosenTemplate">


    <span v-html="templates.find(o=>o.applicationID==chosenTemplate).header"></span> 
    <span v-html="templates.find(o=>o.applicationID==chosenTemplate).body"></span> 

    <div v-if="templates.find(o=>o.applicationID==chosenTemplate).applicationInputID==1">
      
      <select v-model="applicationInputInfo" class="form-select"   >
        <option value="0">აირჩიე საგანი...</option>

        <option v-for="(data,i) of programModules" :key="i" :value="data.module_name">{{ data.module_name }}</option>
    

      </select>
          

    </div>

    <div v-if="templates.find(o=>o.applicationID==chosenTemplate).applicationInputID==2">
      
      <div class="row align-items-center">
        <div class="col-1">
          თარიღი:
        </div>
        <div class="col-4"><input type="date" v-model="applicationInputInfo" class="form-control"/></div>
        <div class="col-4"> - დან</div>
      </div>
     
        
          

    </div>

  <textarea v-if="templates.find(o=>o.applicationID==chosenTemplate).writable" class="form-control" v-model="freeText" style="height: 400px"></textarea>
  
</div>
<div class="d-grid mt-2" v-if="chosenTemplate">
   <button @click="sentApplication(templates.find(o=>o.applicationID==chosenTemplate).applicationInputID)" type="button" class="btn btn-bg-color">განცხადების გაგზავნა</button>
</div>



          

    </div>
      </div>
        
           <div class="row mt-2">
                   <div class="col-12">

                    <div class="row m-4 align-items-center">
                  <div class="col-4 text-center">
                    <i class='bx bx-loader text-warning fs-3'></i> - მიღებულია
                  </div>
                  <div class="col-4 text-center">
                    <i  class='bx bxs-x-circle text-danger fs-3' ></i> - უარყოფილია
                  </div>
                  <div class="col-4 text-center">
                    <i  class='bx bxs-checkbox-checked text-success fs-1' ></i> - დაკმაყოფილებულია
                  </div>
                </div>


                <div class="table-responsive  tisch ">
                    <table class="table" v-if="myApplications.length>0">
  <thead>
    <tr class="color-bg">
    
      <th scope="col">განცხადება</th>
      <th scope="col">თარიღი</th>
      <th scope="col">რეზოლუცია</th>
       <th scope="col">სტატუსი</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="data of myApplications" :key="data.correspondenceID">
     
      <td > <button style="background: transparent;border:none" type="button"   data-bs-toggle="modal" data-bs-target="#showApplication" @click="showApplication(data.correspondenceID)">{{ data.application.applicationName }}</button> </td>
      <td>{{ data.correspondence_date }}</td>
      <td>{{ data.resolution }}</td>
      <td class="fs-3">
        <i v-if="data.statusID==1" class='bx bx-loader text-warning'></i>
          <i v-else-if="data.statusID==3" class='bx bxs-x-circle text-danger' ></i>
          <i v-else class='bx bxs-checkbox-checked text-success' ></i>
      </td>
    </tr>
   
    
  </tbody>
</table>


            </div>


            </div>

        </div>


    </div>

    <div v-if="myApplications.length>0" class="modal fade" id="showApplication" tabindex="-1" role="dialog" aria-labelledby="showApplicationTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">{{ myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.application.applicationName }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        
        <span v-html="myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.application.header"></span>
        <span v-html="myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.application.body"></span>
        <span>{{ myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.freeText }}</span>
        
        <div v-if="myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.application.applicationInputID==1">

          საგანში: {{JSON.parse(myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.applicationInput)[1]}}

        </div>


        <div v-if="myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.application.applicationInputID==2">

          {{JSON.parse(myApplications.find(o=>o.correspondenceID==chosenCorrespondenceID)?.applicationInput)[2]}}-დან
          
        </div>
          






      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
   
      </div>
    </div>
  </div>
</div>
</template>

<script> 
import HttpRequests from '../httpRequests/httpRequests';
const httpRequests=new HttpRequests()
 export default{

  data(){

    return{

      chosenTemplate:0,
      templates:[],
      programModules:[],
      applicationInputInfo:0,
      freeText:null,
      myApplications:[],
      chosenCorrespondenceID:0

    }
  },
  watch:{

    chosenTemplate(val){

      this.applicationInputInfo=0

    }

  },

  mounted(){
    httpRequests.getApplicationTemplates().then(response=>{
      this.templates=response.data
    })

    httpRequests.getModules().then(response=>{
      this.programModules=response.data
    })

    httpRequests.getMyApplications().then(response=>{
      this.myApplications=response.data
    })
  },

    methods:{
      sentApplication(applicationInputID){

          if(applicationInputID>0 && this.applicationInputInfo==0){
            alert("გთხოვთ შეავსოთ ყველა ველი!!!")
            return false
          } 

          if(applicationInputID==0 && this.applicationInputInfo>0){

            this.applicationInputInfo==0

          }

          httpRequests.sentApplication(this.chosenTemplate,applicationInputID,this.applicationInputInfo,this.freeText).then(()=>{
            location.reload()
          })
 


      },
      showApplication(correspondenceID){
        this.chosenCorrespondenceID=correspondenceID
      }
      

    }



 }
</script>
